import { AuthFetch } from "../hooks/useApi";
import { SavePayload, SaveResponse } from "../types/save.types";

export const saveService = {
  post: (
    apiFetch: AuthFetch,
    payload: SavePayload
  ): Promise<SaveResponse> =>
    apiFetch<SaveResponse>("/chat/save", {
      method: "POST",
      body: JSON.stringify(payload),
    }),
};